import React, {useState, useRef} from 'react';
import PropTypes from 'prop-types';

import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/es';

const propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  //value: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}


const CkeditorInput = (props) => {
  const config = {
    toolbar: [
      'heading',
      'bold',
      'italic',
      '|',
      'bulletedList',
      'numberedList',
      'link',
      'insertTable',
      '|',
      'undo',
      'redo'
    ],
    heading: {
      options: [
        { model: 'paragraph', title: 'Párrafo', class: 'ck-heading_paragraph' },
        { model: 'heading5', view: 'h5', title: 'Título Nueva Sección', class: 'ck-heading_heading1' },
      ]
    },
    language: "es"
  }
  return(
    <div>
      <label>{props.label}</label>
      <CKEditor
        editor={ClassicEditor} 
        data={ props.value || "" }
        config={config}
        onChange={ ( event, editor ) => {
            props.onChange(editor.getData(), props.name)
        }}
        disabled={props.disabled}
      />
    </div>
  );
}

CkeditorInput.propTypes = propTypes;

export default CkeditorInput;